/**
 * Link to Indica Ai app landing page.
 * @type {string}
 */
export const LINK_INDICA_AI = 'https://indicaai.quintoandar.com.br';

export const ABOUT_5A_LINK = 'https://press.quintoandar.com.br';

export const MKT_PHOTOGRAPHER = 'https://mkt.quintoandar.com.br/fotografos-quintoandar/';
